import script from "./manage-listings-app.vue?vue&type=script&setup=true&lang=ts"
export * from "./manage-listings-app.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__